exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fc-timegrid-event.selected{background-color:#00bf8f!important;border-color:#00bf8f!important}.fc-timegrid-event.selected .fc-event-main{color:#fff!important}.fc-timegrid-event-harness{margin:15px!important;cursor:pointer!important}", ""]);

// exports
